const BASE_URL = process.env.REACT_APP_WORKER_URL || 'https://pkos-worker.YOUR_SUBDOMAIN.workers.dev';
const TOKEN = process.env.REACT_APP_PKOS_TOKEN || '';

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${TOKEN}`
});

export const api = {
  summary: () => fetch(`${BASE_URL}/summary`, { headers: headers() }).then(r => r.json()),
  rules: {
    get: (domain) => fetch(`${BASE_URL}/rules${domain ? `?domain=${domain}` : ''}`, { headers: headers() }).then(r => r.json()),
    add: (data) => fetch(`${BASE_URL}/rules`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  decisions: {
    get: () => fetch(`${BASE_URL}/decisions`, { headers: headers() }).then(r => r.json()),
    add: (data) => fetch(`${BASE_URL}/decisions`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  mistakes: {
    get: () => fetch(`${BASE_URL}/mistakes`, { headers: headers() }).then(r => r.json()),
    add: (data) => fetch(`${BASE_URL}/mistakes`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  projects: {
    get: () => fetch(`${BASE_URL}/projects`, { headers: headers() }).then(r => r.json()),
    add: (data) => fetch(`${BASE_URL}/projects`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
    update: (data) => fetch(`${BASE_URL}/projects`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  openItems: {
    get: () => fetch(`${BASE_URL}/open-items`, { headers: headers() }).then(r => r.json()),
    add: (data) => fetch(`${BASE_URL}/open-items`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  sessionLog: {
    get: () => fetch(`${BASE_URL}/session-log`, { headers: headers() }).then(r => r.json()),
    add: (data) => fetch(`${BASE_URL}/session-log`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  memory: {
    get: () => fetch(`${BASE_URL}/memory`, { headers: headers() }).then(r => r.json()),
    set: (data) => fetch(`${BASE_URL}/memory`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),
  },
  forgotten: () => fetch(`${BASE_URL}/forgotten`, { headers: headers() }).then(r => r.json()),
};
